import { KnowledgeHubRecordType } from '../types';

export const KNOWLEDGE_HUB_TYPE_CONFIG = {
  [KnowledgeHubRecordType.PRIORITY]: {
    color: 'text-green-800',
    path: 'priorities',
    placeholder: 'I am looking to reduce the manual time spent updating our marketing data.',
  },
  [KnowledgeHubRecordType.OBJECTION]: {
    color: 'text-red-800',
    path: 'objections',
    placeholder: 'We already have a system in place for this.',
  },
  [KnowledgeHubRecordType.QUESTION]: {
    color: 'text-blue-800',
    path: 'questions',
    placeholder: 'How does your pricing structure work?',
  },
  [KnowledgeHubRecordType.HIDDEN_CONTEXT]: {
    color: 'text-purple-800',
    path: 'hidden-gems',
    placeholder: 'I do have funding allocated to new tools, but the budget is still in flux for next quarter.',
  },
};
